import { render, staticRenderFns } from "./newCategories.vue?vue&type=template&id=58d24a34&scoped=true&"
import script from "./newCategories.vue?vue&type=script&lang=js&"
export * from "./newCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d24a34",
  null
  
)

export default component.exports